import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { ComponentProps } from 'react';

type SearchProps = ComponentProps<typeof TextField>;

const Search = (props: SearchProps) => (
  <TextField
    label="Search..."
    variant="outlined"
    onChange={props.onChange}
    id="dimensions-search-input"
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <FontAwesomeIcon icon={faSearch} />
        </InputAdornment>
      ),
    }}
    {...props}
  />
);

export default Search;
